module.exports = __webpack_public_path__ + "img/it.8d15de04.svg";